<template>
  <div>
    <b-modal title="اضافه کردن دانشگاه جدید جهت همکاری صدور مدرک" id="partnerModal" v-model="showModal" no-close-on-esc header-close-variant="dark" hide-footer centered>
      <BaseText :value="model.title" @input="model.title = $event" title="اسم دانشگاه " placeholder="اسم دانشگاه همکار" labelClass="labelClass" />
      <div class="d-flex mt-3">
        <div class="d-flex align-items-center me-1" style="width: 100px">لوگوی دانشگاه</div>
        <ImageUploader
          :img="model.image"
          :uploadLoading="uploadLogoLoading"
          title="عکس مورد نظر را بارگزاری نمایید."
          class="w-100 ms-3"
          @uploadImage="uploadLogo"
          @deleteImage="model.image = ''"
        />
      </div>
      <div class="d-flex justify-content-end align-items-center mt-3 gap-2">
        <b-button variant="secondary" @click="$bvModal.hide('partnerModal'), (model = {})">انصراف</b-button>

        <!-- <b-button variant="primary ms-2 px-5" @click="addCategory">ثبت</b-button> -->
        <Button @click.native="addPartner" :loading="loading" text="ثبت" btnClass="upload-btn btn-border" />
      </div>
    </b-modal>
  </div>
</template>

<script>
import BaseText from '../../common/form/formModules/BaseText.vue'
import skillUpCertificateProvider from '../../../services/skillUp/partner'
import Button from '../../common/Button.vue'
import ImageUploader from '../../user/ImageUploader.vue'
import fileMannager from '../../../services/file'

export default {
  name: 'AddPartner',
  components: { BaseText, Button, ImageUploader },
  props: {
    partner: {
      type: Object,
      default: () => {},
    },
  },
  data: () => {
    return {
      model: {
        id: undefined,
        title: '',
        image: '',
      },
      loading: false,
      uploadLogoLoading: false,
      showModal: false,
      titleError: false,
    }
  },
  watch: {
    partner(val) {
      if (val) this.model = val
    },
    showModal(val) {
      if (!val) {
        this.model = {}
        this.titleError = false
      }
    },
  },
  methods: {
    async uploadLogo(e) {
      this.uploadLogoLoading = true
      const req = await fileMannager.addImage({
        base64image: e.dataUrl,
      })
      this.uploadLogoLoading = false
      this.model.image = req.data.data.downloadUrl
    },
    async addPartner() {
      if (!this.model.title) return (this.titleError = true)
      let result
      const payload = { ...this.model }
      this.loading = true
      try {
        if (this.model && this.model.id) {
          result = await skillUpCertificateProvider.updateCertificate(payload)
        } else result = await skillUpCertificateProvider.AddCertificate(payload)

        if (result.status >= 200 || result.status <= 204) {
          this.$emit('update')
          this.showModal = false
          this.model = {}
        }
        this.loading = false
      } catch (error) {
        this.loading = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.labelClass {
  min-width: 10px !important;
}

.upload-btn {
  margin-right: 10px !important;
  background: #556ee6 !important;
  border-radius: 4px !important;
  color: white !important;
  padding: 8px 28px !important;
}
</style>
